@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  @if (canShowActions($.row, $.adata)) {
    <p-button icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
    styleClass="p-overlayPanel-trigger surface-0 p-button-outlined border-300 ml-2 text-600 text-sm" (click)="action.toggle($event)" aria-label="payment-timeline-actions-button" />
    <p-popover #action styleClass="overflow-hidden text-sm w-10rem -ml-5">
      <ng-template #content>
        <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
          @if ($.adata.includes('editoccurrence') && canShowEditOccurrence($.row) && canDoMidCycleDiscount) {
            <li
              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
              (click)="executeAction('editoccurrence',$.row,action)">
              <i class="fa fa-pen-to-square mr-2"></i>{{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.ACTION' | translate }}
            </li>
          }
          @if ($.adata.includes('retrypayment') && canShowRetry($.row)) {
            <li
              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
              (click)="executeAction('retrypayment',$.row,action)">
              <i class="fa fa-rotate-left mr-2"></i>{{ 'ADMIN.COMMON.RETRY_PAYMENT' | translate }}
            </li>
          }
        </ul>
      </ng-template>
    </p-popover>
  }
}
